// extracted by mini-css-extract-plugin
export var dataCell = "_qv-2";
export var dataRow = "_qv-0";
export var headerRow = "_qv-1";